import { render } from "./MenuWidget.vue?vue&type=template&id=77f35475"
import script from "./MenuWidget.vue?vue&type=script&lang=js"
export * from "./MenuWidget.vue?vue&type=script&lang=js"

import "./MenuWidget.vue?vue&type=style&index=0&id=77f35475&lang=css"

import exportComponent from "/var/www/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__